<!-- site -->
<template>
  <main>
    <section>
      <BaseMenu />
    </section>

    <section class="pt-16">
      <Transition mode="out-in">
        <div class="overflow-hidden">
          <keep-alive>
            <component :is="Home"/>
          </keep-alive>
        </div>
      </Transition>
    </section>

    <Footer />
  </main>
</template>

<script setup>
import BaseMenu from './components/BaseMenu.vue'
import Footer from './components/Footer.vue'
import { initFlowbite } from 'flowbite'
import { onBeforeMount } from 'vue'
import { storeApp } from '@/store'
import Home from './layout/home.vue'
import Loading from './components/Loading.vue'
import SharedService from './services/shared'
import { dataShared } from './store'

onBeforeMount(() => {
  Promise.all([
    dataShared.dispatch('getLogo')
  ])

  window.scrollTo(0, 0)
  // localStorage.clear()
  storeApp.dispatch('hiddenMenuUserLoggedOut')
  initFlowbite()
})
</script>

<style lang="scss">
.v-enter-from,
.v-leave-to {
  transform: translate(50px);
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.anim {
  transition-duration: .5s;

  &:hover {
    transform: translateY(-5px);
    transition-duration: 0.3s;
  }
}

</style>
